<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>ការគ្រប់គ្រងអ្នកណែនាំ</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<el-tabs v-model="tabName">
							<el-tab-pane label="អ្នកណែនាំរងចាំអនុម័ត" name="first"></el-tab-pane>
							<el-tab-pane label="អ្នកណែនាំត្រូវទូទាត់" name="second"></el-tab-pane>
						</el-tabs>

						<div v-if="tabName == 'first'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<label>{{translate(locale.searchUser)}}</label>
										<md-input v-model="search.text" type="text"
											@keyup.enter="searchHandler()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-50 md-size-25">
									<md-field>
										<label>ស្ថានភាព</label>
										<md-select placeholder="ស្ថានភាព (ទាំងអស់)" v-model="search.status">
											<md-option value="">ទាំងអស់</md-option>
											<md-option value="PENDING">រង់ចាំត្រួតពិនិត្យ</md-option>
											<md-option value="APPROVED">បានអនុម័ត</md-option>
											<md-option value="REJECTED">បានបដិសេធ</md-option>
										</md-select>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-50 md-size-25">
									<md-button class="md-raised md-primary" @click="searchHandler()"
										style="width: 100%">{{translate(locale.search)}}</md-button>
								</div>
							</div>
							<md-table v-if="referralList.length > 0">
								<md-table-row>
									<md-table-head></md-table-head>
									<md-table-head>ព័ត៌មានអ្នកស្នើ</md-table-head>
									<md-table-head>ព័ត៌មានគណនីធនាគារ</md-table-head>
									<md-table-head style="min-width: 180px;">ថ្ងៃដាក់ស្នើ</md-table-head>
									<md-table-head>ស្ថានភាព</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(user, index) in referralList">
									<md-table-cell>​{{ index + 1 }}</md-table-cell>
									<md-table-cell><b>{{user.name}}</b> ({{user.phone_number || ""}}{{user.email ||
										""}}) <br>បង្កើតគណនី
										{{config.getAge(user.user_created_date)[1]}}</md-table-cell>
									<md-table-cell><b>{{user.bank_account_name}}</b>
										({{user.bank_name}})<br>{{user.bank_account_number}}</md-table-cell>

									<md-table-cell>
										<b>{{translate(config.datelify(user.created_date))}}</b><br>
										({{translate(config.getAge(user.created_date))}})
									</md-table-cell>
									<md-table-cell>
										<span class="yellow" v-if="user.status == 'PENDING'">រង់ចាំត្រួតពិនិត្យ</span>
										<span class="green" v-if="user.status == 'APPROVED'">បានអនុម័ត</span>
										<span class="red" v-if="user.status == 'REJECTED'">បានបដិសេធ</span>
									</md-table-cell>
									<md-table-cell>
										<md-button class="md-just-icon md-simple md-primary" @click="showQR(user)">
											<md-icon>qr_code_2</md-icon>
											<md-tooltip md-direction="top">មើលលម្អិត</md-tooltip>
										</md-button>
									</md-table-cell>
								</md-table-row>
							</md-table>
							<h5 class="text-center" v-if="referralList.length == 0 && loaded == true">មិនមានអ្នកស្នើសុំ
								។</h5>
							<div class="text-right" v-if="loadMore">
								<md-button class="md-primary"
									@click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
							</div>
						</div>
						<div v-if="tabName == 'second'">
							<div class="md-layout">
								<div class="md-layout-item md-small-size-100 md-size-50">
									<md-field>
										<label>{{translate(locale.searchUser)}}</label>
										<md-input v-model="search_payable.text" type="text"
											@keyup.enter="searchHandler()"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-50 md-size-25">
									<md-field>
										<label>ទឹកប្រាក់ទាបបំផុត</label>
										<md-input type="text" v-model="search_payable.minimum"></md-input>
									</md-field>
								</div>
								<div class="md-layout-item md-small-size-50 md-size-25">
									<md-button class="md-raised md-primary" @click="searchPayableHandler()"
										style="width: 100%">{{translate(locale.search)}}</md-button>
								</div>
							</div>
							<md-table v-if="userPaymentList.length > 0">
								<md-table-row>
									<md-table-head></md-table-head>
									<md-table-head>ព័ត៌មានអ្នកស្នើ</md-table-head>
									<md-table-head>ព័ត៌មានគណនីធនាគារ</md-table-head>
									<md-table-head style="min-width: 180px;">ទឹកប្រាក់ត្រូវទូទាត់</md-table-head>
									<md-table-head>សកម្មភាព</md-table-head>
								</md-table-row>

								<md-table-row v-for="(user, index) in userPaymentList">
									<md-table-cell>​{{ index + 1 }}</md-table-cell>
									<md-table-cell><b>{{user.name}}</b> ({{user.phone_number || ""}}{{user.email ||
										""}}) <br>បង្កើតគណនី {{config.getAge(user.created_date)[1]}}</md-table-cell>
									<md-table-cell><b>{{user.bank_account_name}}</b>
										({{user.bank_name}})<br>{{user.bank_account_number}}</md-table-cell>
									<md-table-cell><b>{{config.moneylify(user.referral_balance)}}</b></md-table-cell>
									<md-table-cell>
										<md-button class="md-just-icon md-simple md-primary" @click="showPay(user)">
											<md-icon>price_check</md-icon>
											<md-tooltip md-direction="top">ទូទាត់</md-tooltip>
										</md-button>
									</md-table-cell>
								</md-table-row>
							</md-table>
							<h5 class="text-center" v-if="userPaymentList.length == 0 && loaded == true">
								មិនមានអ្នកត្រូវទូទាត់ ។</h5>
							<div class="text-right" v-if="loadMore">
								<md-button class="md-primary"
									@click="searchHandler(true)">{{translate(locale.showMore)}}</md-button>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
		<transition name="fade" mode="out-in">
			<div class="md-overlay md-fixed md-dialog-overlay" v-show="action.show" @click="close_dialog()"></div>
		</transition>
		<div class="md-dialog md-theme-default dialog-container" v-if="action.dialog == 'SHOW_QR'">
			<div class="md-layout" style="width: 100%;">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
					style="margin-bottom: 15px;">
					<h4 class="text-primary"><b>ព័ត៌មានគណនីធនាគារ</b></h4>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 30%;">គណនី</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.name}} ({{action.user.phone_number ||
									""}}{{action.user.email || ""}})</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">ឈ្មោះធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_name}}</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">ឈ្មោះគណនីធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_account_name}}</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">លេខគណនីធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_account_number}}</b></md-table-cell>
						</md-table-row>
					</md-table>
					<div style="width: 100%; text-align: center;">
						<img :src="config.cdn + 'bank_qrs/' + action.user.bank_khqr_url"
							style="width: 90%; max-width: 400px;">
					</div>

				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
					<md-field>
						<label>បញ្ចូលមតិករណីបដិសេធ</label>
						<md-input type="text" v-model="action.comment"></md-input>
					</md-field>
				</div>
				<div
					class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
					<md-button class="md-raised md-warn action-button" @click="close_dialog()">បោះបង់</md-button>
					<md-button class="md-raised md-danger action-button" @click="reject()"> បដិសេធ</md-button>
					<md-button class="md-raised md-success action-button" @click="approve()">អនុម័ត</md-button>
				</div>
			</div>
		</div>

		<div class="md-dialog md-theme-default dialog-container" v-if="action.dialog == 'PAY_QR'">
			<div class="md-layout" style="width: 100%;">
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
					style="margin-bottom: 15px;">
					<h4 class="text-primary"><b>ព័ត៌មានគណនីធនាគារ</b></h4>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 30%;">គណនី</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.name}} ({{action.user.phone_number ||
									""}}{{action.user.email || ""}})</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">ឈ្មោះធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_name}}</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">ឈ្មោះគណនីធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_account_name}}</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">លេខគណនីធនាគារ</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{action.user.bank_account_number}}</b></md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell style="width: 30%;">ទឹកប្រាក់ត្រូវទូទាត់</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell><b>{{config.moneylify(action.user.referral_balance)}}</b></md-table-cell>
						</md-table-row>
					</md-table>
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-50 text-center">
					<h4>QR Code ធនាគារ</h4>
					<img :src="config.cdn + 'bank_qrs/' + action.user.bank_khqr_url" style="width: 90%; max-width: 400px;">
				</div>
				<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-50 md-size-50 text-center">
					<h4>រូបភាពបញ្ជាក់ប្រតិបត្តិការ</h4>
					<input type="file" ref="invoice_url" accept="image/png, image/jpeg" @change="handlePoster($event)" style="display: none"/>
					<md-button class="md-raised md-success" @click="$refs.invoice_url.click()" v-if="payment.invoice_url.length == 0">ផ្ទុករូបភាព</md-button>
					<md-button class="md-raised md-danger" @click="payment.invoice_url = ''" v-if="payment.invoice_url.length > 0">លុបចេញ</md-button>
					<img :src="config.cdn + 'transactions/' + payment.invoice_url" style="width: 90%; max-width: 400px;" v-if="payment.invoice_url.length > 0">
				</div>
				<div
					class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
					<md-button class="md-raised md-warn action-button" @click="close_dialog()">បោះបង់</md-button>
					<md-button class="md-raised md-success action-button" @click="pay()">ទូទាត់</md-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		created() {
			this.searchHandler();
			this.searchPayableHandler();
		},
		data() {
			return {
				tabName: 'first',
				loaded: false,
				loadMore: false,
				search: {
					text: "",
					status: ""
				},
				referralList: [],
				userPaymentList: [],
				action: {
					show: false,
					dialog: "",
					user: null,
					comment: ""
				},
				search_payable: {
					text: "",
					minimum: 200000
				},
				payment: {
					user_hash: "",
					amount: "",
					invoice_url: ""
				}
			}
		},
		methods: {
			searchHandler(more = false) {
				let size = 100;
				this.$http.post(this.config.api + "/user/referral/search", {
					text: this.search.text,
					status: this.search.status,
					size: size,
					offset: more ? this.referralList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.referralList = more ? this.referralList.concat(data.body.data) : data.body.data;
				})
			},
			searchPayableHandler(more = false) {
				let size = 100;
				this.$http.post(this.config.api + "/user/referral/search_payable", {
					text: this.search_payable.text,
					minimum: this.search_payable.minimum,
					size: size,
					offset: more ? this.userPaymentList.length : 0
				}).then(data => {
					this.loaded = true;
					if (data.body.data.length == size) this.loadMore = true;
					else this.loadMore = false;
					this.userPaymentList = more ? this.userPaymentList.concat(data.body.data) : data.body.data;
				})
			},
			showQR(user) {
				this.action.show = true;
				this.action.dialog = "SHOW_QR";
				this.action.user = user;
			},
			showPay(user) {
				this.action.show = true;
				this.action.dialog = "PAY_QR";
				this.action.user = user;
				this.payment.user_hash = user.hash;
				this.payment.amount = user.referral_balance;
			},
			reject() {
				if (!this.action.user.hash || !this.action.comment) return false;
				this.$http.post(this.config.api + "/user/referral/reject", {
					hash: this.action.user.hash,
					comment: this.action.comment
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "បដិសេធជោគជ័យ។", icon: 'done', type: 'success' })
						this.searchHandler();
						this.close_dialog();
					}
				})
			},
			approve() {
				if (!this.action.user.hash) return false;
				this.$http.post(this.config.api + "/user/referral/approve", {
					hash: this.action.user.hash
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "អនុម័តជោគជ័យ។", icon: 'done', type: 'success' })
						this.searchHandler();
						this.close_dialog();
					}
				})
			},
			pay() {
				if (!this.payment.user_hash || !this.payment.amount || !this.payment.invoice_url) return false;

				this.$http.post(this.config.api + "/user/referral/pay", {
					hash: this.payment.user_hash,
					amount: this.payment.amount,
					invoice_url: this.payment.invoice_url
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({ message: "បានទូទាត់ជោគជ័យ។", icon: 'done', type: 'success' })
						this.searchPayableHandler();
						this.close_dialog();
					}
				})
			},
			handlePoster(event) {
				if (!event.target.files.length) return;

				const formData = new FormData();
				formData.append('file', this.$refs.invoice_url.files[0]);
				this.$http.post(this.config.api + "/user/file/transaction", formData).then(res => {
					if (res.body.status == 'success') {
						this.payment.invoice_url = res.body.data.file_hash;
					}
				})
			},
			close_dialog() {
				this.action.show = false;
				this.action.dialog = "";
				this.action.user = null;
				this.action.comment = "";
				this.payment.user_hash = "";
				this.payment.amount = "";
				this.payment.invoice_url = "";
			},
		}
	}
</script>
<style scoped>
	.dialog-container {
		width: 90%;
		max-width: 1000px !important;
		padding: 15px;
		border-radius: 6px;
		overflow-y: scroll;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity .1s
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0
	}

	.action-button {
		margin-left: 8px !important;
	}

	.action-button {
		margin-left: 8px !important;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Referral/View.vue